import { localize } from 'monaco-editor/esm/vs/nls.js';
import { RawContextKey } from 'monaco-editor/esm/vs/platform/contextkey/common/contextkey.js';
const CONTEXT_RESPONSE_HAS_PROVIDER_ID = ( new RawContextKey(
 'interactiveSessionResponseHasProviderId',
 false,
 { type: 'boolean', description: ( localize(
  'interactiveSessionResponseHasProviderId',
  "True when the provider has assigned an id to this response."
 )) }
));
const CONTEXT_RESPONSE_VOTE = ( new RawContextKey(
 'interactiveSessionResponseVote',
 '',
 { type: 'string', description: ( localize(
  'interactiveSessionResponseVote',
  "When the response has been voted up, is set to 'up'. When voted down, is set to 'down'. Otherwise an empty string."
 )) }
));
const CONTEXT_INTERACTIVE_REQUEST_IN_PROGRESS = ( new RawContextKey(
 'interactiveSessionRequestInProgress',
 false,
 { type: 'boolean', description: ( localize(
  'interactiveSessionRequestInProgress',
  "True when the current request is still in progress."
 )) }
));
const CONTEXT_INTERACTIVE_INPUT_HAS_TEXT = ( new RawContextKey(
 'interactiveInputHasText',
 false,
 { type: 'boolean', description: ( localize('interactiveInputHasText', "True when the interactive input has text.")) }
));
const CONTEXT_IN_INTERACTIVE_INPUT = ( new RawContextKey(
 'inInteractiveInput',
 false,
 { type: 'boolean', description: ( localize(
  'inInteractiveInput',
  "True when focus is in the interactive input, false otherwise."
 )) }
));
const CONTEXT_IN_INTERACTIVE_SESSION = ( new RawContextKey(
 'inInteractiveSession',
 false,
 { type: 'boolean', description: ( localize(
  'inInteractiveSession',
  "True when focus is in the interactive session widget, false otherwise."
 )) }
));
const CONTEXT_PROVIDER_EXISTS = ( new RawContextKey(
 'hasInteractiveSessionProvider',
 false,
 { type: 'boolean', description: ( localize(
  'hasInteractiveSessionProvider',
  "True when some interactive session provider has been registered."
 )) }
));
export { CONTEXT_INTERACTIVE_INPUT_HAS_TEXT, CONTEXT_INTERACTIVE_REQUEST_IN_PROGRESS, CONTEXT_IN_INTERACTIVE_INPUT, CONTEXT_IN_INTERACTIVE_SESSION, CONTEXT_PROVIDER_EXISTS, CONTEXT_RESPONSE_HAS_PROVIDER_ID, CONTEXT_RESPONSE_VOTE };
